/**
 * narcisSignInCard — Narcis's own surface on the shared sign-in card (`@core/auth-ui/SignInCard`,
 * pattern `products/toile/wall/signInCard.tsx` / `products/ovid/wall/signInCard.tsx`). The mark and
 * the two pages this house shelves its policy at. The card's own default copy and stylesheet are
 * the ones Toile shipped, so nothing else is stated here.
 */
import {NarcisMark} from './NarcisMark'

export const NARCIS_SIGN_IN_CARD = {
    glyph: {mark: <NarcisMark size={42} />, word: 'narcis'},
    termsHref: '/terms',
    // Narcis has one combined terms/privacy page (`routes/_layout.terms.tsx`, no separate
    // `/privacy` route) — the same `#tos-10` anchor the existing `components/SignInCard/SignInCard
    // .tsx:309` links its own "Privacy Policy" word through.
    privacyHref: '/terms#tos-10',
}
